export const GALLERY_QR_PREVIEW_MS = 15000;
export const GALLERY_QR_OVERLAY_MS = 5000;
